import { Component, ChangeDetectionStrategy } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-tyokielto-paata-dialog',
  templateUrl: './tyokielto-paata.dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsiakasAsetuksetTyokieltoPaataDialog {
  constructor(private dialogRef: MatDialogRef<AsiakasAsetuksetTyokieltoPaataDialog>) {}

  tallenna() {
    this.dialogRef.close(true)
  }
}
